// extracted by mini-css-extract-plugin
module.exports = {"headerImage":"header-module--headerImage--1oirn"};